import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
  Typography,
  styled,
} from '@material-ui/core';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
  '& .MuiDialog-paperWidthSm': {
    backgroundColor: '#322d38',
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    width: '500px',
    padding: '0px',
  },
  '& .MuiDialogContent-dividers': {
    borderTop: '0px',
    borderBottom: '0px',
    width: '100%',
  },
  '& .MuiTypography-h6': {
    textTransform: 'none',
    fontSize: '1.8rem',
  },
  '& .input': {
    width: '100%',
    padding: '10px',
    backgroundColor: '#000000',
    border: '1px solid #3d3d3d',
    borderRadius: '4px',
    color: '#ffffff',
  },
  '& .input:focus': {
    outline: '1px solid #0d6efd',
  },
  '& .input_error': {
    width: '100%',
    padding: '10px',
    backgroundColor: '#1a1a1a',
    border: '2px solid #ff0000',
    borderRadius: '4px',
    color: '#ffffff',
  },
  '& .MuiFormLabel-root': {
    color: '#fff',
  },
  '& .MuiInputBase-root': {
    color: '#fff',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#3d3d3d',
  },
  '& .MuiButton-root': {
    padding: '10px 20px',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '14px',
    transition: 'background 0.3s',
    textTransform: 'capitalize',
  },
}));

const DeleteUserConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  username,
  isLoading,
}) => {
  const [inputUsername, setInputUsername] = useState('');
  const [isValid, setIsValid] = useState(true);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputUsername(value);
    setIsValid(true);
  };

  const handleConfirm = () => {
    if (inputUsername.toLowerCase() !== username.toLowerCase()) {
      setIsValid(false);
      return;
    }
    onConfirm();
    setInputUsername('');
  };

  const handleClose = () => {
    setInputUsername('');
    setIsValid(true);
    onClose();
  };

  return (
    <BootstrapDialog
      open={open}
      onClose={handleClose}
      aria-labelledby="delete-dialog-title"
    >
      <DialogTitle id="delete-dialog-title" style={{ color: '#fff' }}>
        Delete User
      </DialogTitle>
      <DialogContent dividers>
        <Fragment>
          <Typography style={{ color: '#ff6b6b', marginBottom: '16px' }}>
            ⚠️ Warning: This action is permanent and cannot be undone.
          </Typography>
          <Typography style={{ color: '#fff', marginBottom: '12px' }}>
            To confirm deletion of user <strong>{username}</strong>, please enter
            the username below:
          </Typography>
          <TextField
            autoFocus
            margin="dense"
            id="confirm-username"
            label="Username"
            type="text"
            fullWidth
            variant="outlined"
            value={inputUsername}
            onChange={handleInputChange}
            error={!isValid}
            helperText={!isValid ? 'Username does not match' : ''}
            disabled={isLoading}
            style={{ marginTop: '16px' }}
          />
        </Fragment>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleClose}
          disabled={isLoading}
          style={{ color: '#fff' }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          disabled={isLoading || !inputUsername}
          style={{
            color: '#fff',
            backgroundColor: '#dc3545',
            marginLeft: '8px',
          }}
          variant="contained"
        >
          {isLoading ? 'Deleting...' : 'Delete User'}
        </Button>
      </DialogActions>
    </BootstrapDialog>
  );
};

DeleteUserConfirmationDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  username: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
};

DeleteUserConfirmationDialog.defaultProps = {
  isLoading: false,
};

export default DeleteUserConfirmationDialog;
